import styled from "styled-components";

import AppBar from '@material-ui/core/AppBar';

export const ContainerAppBar = styled.div`
  flex-grow: 1;
  background-color: #FFF;
`;

export default styled(AppBar)`
  background-color: #095AA5;
  border-radius: 8px;
  padding: 10px 20px;

  .MuiTab-textColorPrimary {
    color: #FFF;
    border-radius: 8px;
  }

  .MuiTab-textColorPrimary.Mui-selected {
    color: #FFF;
    background-color: #FF690A;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  }

  .PrivateTabIndicator-colorPrimary-3 {
    background: transparent;
  }

  .PrivateTabIndicator-root-2 {
    height: 4px;
    transition: .1s;
  }
`;

export const BoxPanel = styled.div`
  & > div > div {
    padding: 20px 0px 0px 0px;
  }
`;
